import { ErrorResponse, handlerApiError } from '../../../../lib/basicRepository';
import { restApi } from '../../../../services/api';
import { onlineOrdersRepository } from '../../../orders/repositories/ordersRepository/onlineOrdersRepository';
import { KitActionsRequestParams } from '../types/kitActions.types';
import { ProductActionsResponseData } from '../types/productActions.types';

const unshopKit = async ({ kitId, orderId }: KitActionsRequestParams) => {
  const response = await restApi.post<ProductActionsResponseData, ErrorResponse>(
    `/products/actions/unshop`,
    {
      kitId,
      orderId,
    },
  );
  return handlerApiError<ProductActionsResponseData>(response);
};

const shopKit = ({ kitId, orderId }: KitActionsRequestParams) => {
  return onlineOrdersRepository(orderId).createOrUpdateOrderListWithKit({
    kitId,
    orderId,
    quantity: 1,
  });
};

export const onlineKitActionRepository = {
  unshopKit,
  shopKit,
};
